import React from 'react';

const ImportContact = () => {
    return <h1>Import Contact</h1>;
};

export default ImportContact;
